import React from 'react';

interface FormRadioOption {
  value: string;
  label: React.ReactNode;
}

interface FormRadioGroupProps {
  label: React.ReactNode;
  name: string;
  value: string;
  onChange: (name: string, value: string) => void;
  options: FormRadioOption[];
}

const FormRadioGroup = ({ label, name, value, onChange, options }: FormRadioGroupProps) => (
    <div className="mt-2">
        <label className="block text-sm font-medium text-gray-700 mb-2">{label}</label>
        <div className="flex items-center gap-4">
            {options.map(opt => (
                <label key={opt.value} className="flex items-center gap-2 cursor-pointer">
                    <input type="radio" name={name} value={opt.value} checked={value === opt.value} onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(name, e.target.value)}
                        className="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-500" />
                    <span className="text-sm text-gray-700">{opt.label}</span>
                </label>
            ))}
        </div>
    </div>
);

export default FormRadioGroup;
